module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e3254NaN"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e278828"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_toc_r1#d6e4",
      "id": "d7e4"
    }
  }, [_vm._v("Chapter 3 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e279328"
    }
  }, [_vm._v("“Wake up!” My ears stung from Matthew’s burning tongue. My eyes shot open. I was sitting on a cold, metal chair in a white room with blinding lights. Only a glass table separated Matthew and me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e281128"
    }
  }, [_vm._v("“Every child takes the S.S. Pill when they are fifteen,” Matthew stated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e281928"
    }
  }, [_vm._v("“So you brought me here to take the pill?” I snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e282528"
    }
  }, [_vm._v("“No, you’re different,” Matthew said. “Do you remember what I said about the soldiers?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e283328"
    }
  }, [_vm._v("“Why don’t you tell the Community what’s really happening with the War? You’re the one attacking, not defending. We’re hardly suffering from the war and other communities’ assaults. Why are you telling me all of this? Why did you pick me up from school?” I wanted answers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e285128"
    }
  }, [_vm._v("Matthew smiled evilly. “They wouldn’t understand. You see, once in a while, a child is born with black hair and purple eyes. These children take the S.S. Pill at birth and have a high place in society—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e286328"
    }
  }, [_vm._v("“But your eyes aren’t purple and your hair isn’t black,” I interrupted. “How could physical appearances affect our social status?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e287428"
    }
  }, [_vm._v("“Take a closer look.” Matthew moved closer, his face inches from mine. He blinked a couple of times, revealing his electric, violet eyes. I couldn’t believe what I was seeing. His thick hair was a dull, coal black. For the first time in my life I didn’t feel like the only mutant of Tamizeh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e289829"
    }
  }, [_vm._v("“Alexia, you will have to go to another school from now on to train for your position in this community,” Matthew said as he started to pace around the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e291029"
    }
  }, [_vm._v("“Where? Why now? Why doesn’t anyone else know of this?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e291529"
    }
  }, [_vm._v("“I ask the questions!” Matthew snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e292129"
    }
  }, [_vm._v("I felt betrayed. I formed a fist, holding back my words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e292629"
    }
  }, [_vm._v("“You will go back to Lyli’s house. More will be explained later. You will be picked up again soon. For obvious reasons, this conversation remains private and unknown to the rest of the community. Any sharing of information with someone else, even Lyli, will result in grave consequences, with death being one of the options. No more questions. You are dismissed. One of my men will show you out.” Matthew didn’t even look at me. He marched out with his head held high.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e295429"
    }
  }, [_vm._v("I waited motionless and mute. My life was about to change.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e295929"
    }
  }, [_vm._v("A young man in a black soldier uniform walked through the door, wrapped his large hand around my upper left arm, locked his grip, and pulled me out of the room. I didn’t oppose. I just wanted to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e297129"
    }
  }, [_vm._v("We walked down a bright hallway with snow-white walls and soft, metal accents running across the ceiling. Glass doors with restricted access were on both sides of the hallway. I closed my eyes. My head was still spinning. Our footsteps resonated down the deserted walkway, sounding like pounding hammers on resilient granite. My ears started to ring with every step as we furthered into the corridor. We walked until my legs ached and couldn’t support me any longer. The soldier was practically dragging me. I didn’t know where we were going or how long it would take for us to get there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e300630"
    }
  }, [_vm._v("I heard the soldier take out his ID card and swipe it. “Soldier 122569, Antony Marks,” the voice recognizer said. I would hate being numbered and tagged; it was demoralizing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e301730"
    }
  }, [_vm._v("I slowly opened my eyes as the soldier unlatched the door. A bursting light blinded me, and a cold breeze chilled my core. He gave me a slight push, then shut the door in my face. I was standing in the middle of a street.The small portal slowly faded away, then disappeared. Transportation was fast, but untraceable, which was kind of scary. You couldn’t trace your steps if you got lost. It was making me question our Community’s safety and security.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e304430"
    }
  }, [_vm._v("I looked around. The sun was blinding, but its warmth wrapped around me. The plain, white houses all looked alike. The streets were deserted, mainly because everyone was either at work or at school. The tall, thin pine trees were dancing in the wind, and the Thase River that encircled our Community quietly flowed down the bank. These trees were so different than the large, old, massive oak trees skirting Tamizeh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e307030"
    }
  }, [_vm._v("I headed toward a large willow tree. It sat at the edge of the flowing water, its leaves bending just enough to skim the water’s clear surface. I sat on one of its strong roots that emerged from the thick, fertile dirt and gazed into the water to contemplate my reflection. Black hair framed my face and contrasted with my ashy skin. My small nose was centered between my high cheekbones, and even through the water’s reflection my purple eyes sparkled. My prominent jawline followed my thin neck, while my clavicles were rather obvious and stood out. I had always been small-boned, but never really short. Lyli always wanted me to wear dresses, but I hated them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e310730"
    }
  }, [_vm._v("As I looked at myself, so many questions overlapped in my head, but what bothered me the most was a feeling deep inside of me, burning between my abdomen and my heart. I knew Matthew was hiding something from me. He had revealed many secrets about how  he ruled our Community, but something was wrong. As he had spoken to me, he was trying to breathe calmly, but his violet eyes had betrayed him. He was afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e313631"
    }
  }, [_vm._v("I stayed there for a while to think and get away from it all. Since Matthew had revealed his true colors to me, I no longer felt like the outcast or the faulty one. But at the same time, I wasn’t sure what it all meant. I wasn’t even sure what had just happened and why Matthew had taken me to some unknown location. More than ever, I wanted to be like everyone else, with brown hair and blue eyes. I couldn’t erase Matthew’s charcoal hair and purple eyes from my mind. I didn’t want to be like Matthew. I softly cried by the side of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "9781937084318-txt_0031_001",
      "id": "d14e663",
      "src": "images/9781937084318-txt_0031_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e316831"
    }
  }, [_vm._v("Lyli was waiting for me at the door with her penetrating blue gaze. “So what was that about? More tests?” she said with a fake smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e318331"
    }
  }, [_vm._v("I had been taken out of school for testing in the past. Some were written, others oral, and a few physical ones. Lyli had checkups when her parents took her to the doctor’s office, so I figured that my tests were different because I didn’t have parents to take me. But after having had that weird meeting with Matthew, I knew better. What had happened between the time that I had fallen asleep to when I had woken up? Trouble seemed to be in my shadow no matter where I was or what I did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e321131"
    }
  }, [_vm._v("“Yes,” I replied with a dagger in my stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e321631"
    }
  }, [_vm._v("As we stepped into the house, the alarm blared. The solar panels allowed all of the electricity to be stored, so the lights turned on when we walked in. The alarm recognized us and settled down. Lyli sat in the living room and turned on the hologram television. I walked up the carved, winding staircase.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e323431"
    }
  }, [_vm._v("As I entered my room, I found a beautifully wrapped package in neon-green paper sitting on my bed. I unwrapped the gift. It was an  anti-gravity ring, the newest model. Not only did it counter gravity, but it could also tell time, and it was waterproof, just like the one Matthew had used in his car. The thin, silver band caught the light beautifully. I quickly slipped it onto my finger and ran downstairs, jumping the last couple of stairs to thank Lyli for the present. But as I reached the bottom, my heart leapt to my throat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e326632"
    }
  }, [_vm._v("“Glad to see you like it. I picked it out myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e327132"
    }
  }, [_vm._v("Matthew was standing in our foyer holding a suitcase in his left hand. He smiled as he handed me a black duffle bag. Lyli and her parents were standing there, frozen, as if they had been placed in ice. I had expected to see him again, but not this soon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e328632"
    }
  }, [_vm._v("Matthew said with a firm voice, “You need to pack some clothes, and we need to leave now.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e329532"
    }
  }, [_vm._v("“I can’t leave!” I shouted. This was the only home I had ever known. Rage bubbled inside of me, ready to burst.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e330532"
    }
  }, [_vm._v("“Yes, you can. You need to go to H.S.H.S. where you will be trained. Your position is one of the highest ranks. Don’t worry,” he said, pointing to Lyli and her parents. “They won’t remember this. Their minds are blocked, and they’re frozen. It’s as if they aren’t here right now. Now hurry up. You have a lot of intensive training waiting for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e332532"
    }
  }, [_vm._v("I stared at Lyli and suddenly realized that he was right—she was frozen. All of them were frozen. Nothing made any sense. “I never agreed to this! What is H.S.H.S. anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e333732"
    }
  }, [_vm._v("“High Society High School. And you never had to agree, because it’s not your choice. It was decided for you. You have been chosen simply because you have violet eyes and black hair. I’m not asking you to go; I’m ordering you!” Matthew was starting to raise his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e335232"
    }
  }, [_vm._v("“I refuse to go! I didn’t ask for violet eyes or black hair.” My eyes blurred with tears as I looked at Lyli’s father, who was holding his wife’s hand tenderly. A tormenting ache burned in my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e336432"
    }
  }, [_vm._v("“If you didn’t have violet eyes, you would be brain damaged!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e337433"
    }
  }, [_vm._v("“What’s that supposed to mean? Are you saying that everyone with blue eyes and brown hair is brain damaged?” My head pounded. Lyli’s blank doe eyes just looked through me as if I wasn’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e338533"
    }
  }, [_vm._v("“When they’re born, they take the C.I. Pill: Cerebrum Impairment. They don’t have any feelings, and they have no idea what they are doing. All they know is how to take orders and not cause any trouble. If you put them in a difficult situation, they won’t know what to do, so they will laugh, agree with whomever, or simply stay silent. I’m sure you’ve come across your host family freezing up like that. You have to come now! Your friend won’t care,” Matthew said nonchalantly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e341033"
    }
  }, [_vm._v("I felt like I was being strangled. I stared at Lyli in horror. Everything suddenly made sense. I hated the C.I. Pill. It was completely inhumane to take away people’s thoughts, all of their thoughts. People weren’t supposed to be controlled. Lyli, from birth, had been stripped of her humanity and turned into a robot. I could barely breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e342833"
    }
  }, [_vm._v("I tried to run past him, but he caught my wrist. The grip was tight, his hand frozen, and his glare icy. Matthew was strong, and he forced me to kneel below him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e344033"
    }
  }, [_vm._v("“Remember, you have strength, Alexia. Accept it and take your place. The Community takes the S.S. Pill for battle, but you have developed further and are superior. Use it as I tell you. You need to understand that this is what you’ve been designed to do.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e345433"
    }
  }, [_vm._v("I laughed sarcastically through my tears. “You lie to the Community!” I pulled my arm, trying to free myself of his grip. “You always say you’re protecting us and allowing us to grow and prosper, but you’ve only been destroying us and rendering us weak and dependent on you!” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e346933"
    }
  }, [_vm._v("He slowly twisted my wrist. I bent backward in pain, and my limbs felt as though they were slowly being pulled apart. I begged for him to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e348133"
    }
  }, [_vm._v("“Shut up and fight back!” he yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e348633"
    }
  }, [_vm._v("“No!” I cried. I wasn’t going to give him what he wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e349734"
    }
  }, [_vm._v("“Then you’ll come!” Matthew screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e350234"
    }
  }, [_vm._v("“Never!” I was dying inside, choking on my saliva and drowning in my cries.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e351034"
    }
  }, [_vm._v("He slowly let go of my hand, but as soon as I tried to run, he grabbed my arm again. Then he ripped me through the house, out the door, and shoved me into his car.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e352234"
    }
  }, [_vm._v("I knew that I would never return to the only place I had ever called home.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546b0fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lodi_9781937084325_epub_c6_r1.vue
// module id = 75
// module chunks = 0